import React from 'react';
import { useDrag } from 'react-dnd';
import { ItemTypes, PlayerEnum } from './constants';
import styled from 'styled-components';
import { IPlayer } from '../../../../shared/types/player.type';

const StyledPlayer = styled.span<
  { $isDragging: string } & { $number: PlayerEnum }
>`
  opacity: ${(props) => (props.$isDragging === 'true' ? 0.1 : 1)};
  color: ${(props) => {
    switch (props.$number) {
      case PlayerEnum.ONE:
        return props.theme.playerOne;
      case PlayerEnum.TWO:
        return props.theme.playerTwo;
      case PlayerEnum.THREE:
        return props.theme.playerThree;
      case PlayerEnum.FOUR:
        return props.theme.playerFour;
    }
  }};
  font-size: 2em;
  text-shadow:
    -3px 0 black,
    0 -3px black,
    0 3px black,
    3px 0 black;
`;

export default function Player(props: Pick<IPlayer, 'number' | 'id'>) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.PLAYER,
    item: props,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));
  return (
    <StyledPlayer
      ref={drag}
      $isDragging={isDragging.toString()}
      $number={props.number}
    >
      ♟︎
    </StyledPlayer>
  );
}
